<template>
  <div>
    <c-button class="btn btn-primary" @click="doVRTCheck">
      <c-spinner v-if="isRunningCheck" color="success" size="sm" />
      <span v-else>Perform VRT check</span>
    </c-button>
    <c-row v-if="error" class="mt-2">
      <c-col>
        <p class="lead">Error: {{ error }}</p>
      </c-col>
    </c-row>
    <c-row v-if="action" class="mt-2">
      <c-col>
        <p class="lead">{{ action }}</p>
      </c-col>
    </c-row>

    <template v-if="checkComplete">
      <c-row class="p-3">
        <c-col v-for="(screen, i) in results.screensCompared" :key="`${i}_screen`">
          <p>{{ screen.large.createdAt | dateFormatRelative }}</p>
          <img :src="screen.large.url" class="img-fluid" />
        </c-col>
      </c-row>
      <c-row class="p-3">
        <c-col>
          <h2>Mismatch: %{{ results.result.misMatchPercentage }}</h2>
        </c-col>
        <c-col>
          <img :src="results.diffImage.large.url" class="img-fluid" />
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'VRT',
  props: {
    siteId: String,
  },
  data() {
    return {
      isRunningCheck: false,
      action: '',
      error: null,
      checkComplete: false,
      results: null,
    };
  },
  methods: {
    doVRTCheck() {
      this.checkComplete = false;
      this.isRunningCheck = true;
      this.action = 'Taking a screenshot...';

      // Take screenshot
      this.takeScreenshot((err) => {
        this.action = '';
        if (err) {
          this.isRunningCheck = false;
          this.error = 'Error taking screenshot';
        }
        // Compare screenshot
        this.action = 'Comparing screens...';
        this.$http
          .get(buildEndpoint('site/compare-screens/') + this.siteId)
          .then((response) => {
            this.isRunningCheck = false;
            this.action = '';
            this.error = null;
            console.log(response);
            if (response.data.success) {
              this.results = response.data.data;
              this.checkComplete = true;
            } else {
              this.error = 'Error getting site data';
            }
          })
          .catch((error) => {
            this.error = error.message;
          });
      });
    },
    takeScreenshot(callback) {
      this.$http
        .get(`${buildEndpoint('site/take-screenshot/') + this.siteId}/desktop`)
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            return callback();
          }
          callback(error);
        })
        .catch((error) => {
          callback(error);
        });
    },
  },
};
</script>
